var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 62,
  height: 62,
  viewBox: "0 0 60 60",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "white",
  stroke: "white",
  strokeWidth: 2
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  opacity: 0.802,
  cx: 30,
  cy: 30,
  r: 28.5,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.5 30l-21 12V18z"
}))));
export default SvgPlay;